import { createSelector } from 'reselect';

export const selectStateSearch = () => state => state.search;

export const selectQuery = () =>
  createSelector(selectStateSearch(), search => search.query);

export const selectResults = () =>
  createSelector(selectStateSearch(), search => search.items);

export const selectTotal = () =>
  createSelector(selectStateSearch(), search => search.total);

export const selectSize = () =>
  createSelector(selectStateSearch(), search => search.size);

export const selectPage = () =>
  createSelector(selectStateSearch(), search => search.page);

export const selectAllTotal = () =>
  createSelector(selectStateSearch(), search => ({
    all: search.totalAll,
    contents: search.totalContents,
    documents: search.totalDocuments,
    folders: search.totalFolders,
    users: search.totalUsers,
    associations: search.totalAssociations
  }));

export const selectCategory = () =>
  createSelector(selectStateSearch(), search => search.category);
